import { Modal } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReactPlayer from 'react-player'

type Props = {
    isOpen: boolean
    handleClose: () => void
    videoSrc: string
}

export default function VideoModal({ isOpen, handleClose, videoSrc }: Props) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const videoRef = useRef<ReactPlayer>(null)
    const { t } = useTranslation('ContestantDetails')

    useEffect(() => {
        function handleChangeWindowSize() {
            setWindowWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleChangeWindowSize)

        return () => {
            window.removeEventListener('resize', handleChangeWindowSize)
        }
    }, [])

    function close() {
        if (videoRef.current) {
            videoRef.current.getInternalPlayer().pauseVideo()
        }
        handleClose()
    }

    return (
        <Modal title={t('Introduction video')} open={isOpen} onCancel={close} centered width={windowWidth > 1024 ? '40%' : '80%'} footer={null}>
            <ReactPlayer url={videoSrc} ref={videoRef} controls width="100%" height="500px" />
        </Modal>
    )
}
